import { Color } from '@tmh-website/shared/colors';
import StyledTypo from '@tmh-website/styles/typo';
import { DropdownThemeColor, dropdownThemes } from '@tmh-website/ui/Dropdown';
import transparentize from 'polished/lib/color/transparentize';
import styled, { css } from 'styled-components';

export const Container = styled.button<{ $themeColor: DropdownThemeColor; $isActive: boolean }>`
  ${StyledTypo.uiTextCss};
  position: relative;
  display: block;
  width: 100%;
  padding: 8px 24px;
  color: ${props =>
    props.theme.color[
      props.$isActive ? dropdownThemes[props.$themeColor].textChecked : dropdownThemes[props.$themeColor].text
    ]};
  text-align: start;
  cursor: pointer;
  background-color: ${props => props.theme.color[dropdownThemes[props.$themeColor].normal]};
  border: none;
  transition: all ${props => props.theme.transitionTiming};
  transition-property: background-color color;
  ${props => props.$isActive && 'pointer-events: none;'};
  @media (${props => props.theme.breakpoint.sm.down}) {
    padding: 12px 24px;
  }

  &:hover {
    text-decoration: none;
  }

  &:last-child {
    border-bottom: none;
  }

  &:focus-visible {
    outline: none;
    box-shadow: inset ${props => props.theme.focusBoxShadow} ${props => props.theme.color[Color.Blue_500_Ultramarine]};
  }

  ${props =>
    !props.disabled &&
    css`
      color: ${props.theme.color[dropdownThemes[props.$themeColor].text]};
      &:focus-visible,
      &:hover {
        background-color: ${props.theme.color[dropdownThemes[props.$themeColor].hover]};
      }

      &:active {
        background-color: ${props.theme.color[dropdownThemes[props.$themeColor].active]};
      }
    `};

  ${props =>
    props.disabled &&
    css`
      color: ${transparentize(
        0.4,
        props.theme.color[
          props.$isActive ? dropdownThemes[props.$themeColor].textChecked : dropdownThemes[props.$themeColor].text
        ]
      )};
      cursor: not-allowed;

      &:active {
        pointer-events: none;
      }
    `};
`;
